<template>
    <CRow>
        <CCol col>
            <div id="derivedPricesTab">
                <div class="derived-price-padding"></div>
                <ejs-datepicker ref="dateObj" :placeholder="waterMark" v-model="dateVal" :format="dateFormat" :focus='onFocus' :firstDayOfWeek='1' :max='maxVal' width=180></ejs-datepicker>
                <div style="width:100%; height: 80vh;">
                    <ejs-grid ref='grid' id="derivedPricesGrid" created="created" :dataSource="derivedPricesData" :allowFiltering='true' :allowPaging="true" :allowResizing='true'
                              :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete'
                              :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar'
                              :pageSettings='pageSettings' :actionBegin='actionBegin' :actionComplete='actionComplete'
                              :actionFailure="actionFailure" :query='gridQuery' :filterSettings='filterOptions' width="100%" height="100%">
                        <e-columns>
                            <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='year' headerText='Year' textAlign='Left' width=120 type="number"></e-column>
                            <e-column field='periodName' headerText='Period Indicator' textAlign='Left' width=180 type="string"></e-column>
                            <e-column field='periodSpanName' headerText='Period' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='derivedCurveIdentifier' headerText='Derived Curve Identifier' textAlign='Left' width=160></e-column>
                            <e-column field='stateName' headerText='Country' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' textAlign='Left' width=130 type="string"></e-column>
                            <e-column field='product' headerText='Product' textAlign='Left' :allowEditing="false" width=160></e-column>
                            <e-column field='date' headerText='Report Date' textAlign='Left' :validationRules="requiredRules" :format='dateFormatOptions' type='date' :edit="dateParams" width=180></e-column>
                            <e-column field='universalClosePriceDate' headerText='Settlement Date' textAlign='Left' :validationRules="requiredRules" :format='dateFormatOptions' type='date' :edit="dateParams" width=180></e-column>
                            <e-column field='price' headerText='Settlement Price' textAlign='Left' format='n3' width=180></e-column>
                            <e-column field='tradingUnitPreview' headerText='Trading Unit' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='createdBy' headerText='Created By' textAlign='Left' :allowEditing="false" width=150></e-column>
                            <e-column field='createdDate' headerText='Import Date' textAlign='Left' :allowEditing="false" :format='dateFormatOptions' type='date' width=150></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";

    import {
        GridPlugin,
        Edit,
        Page,
        Toolbar,
        Sort,
        Filter,
        Reorder,
        Resize,
        ExcelExport,
        ForeignKey
    } from "@syncfusion/ej2-vue-grids";
    import { Query, DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import authToken from '../../common/authToken';
    import urls from '../../common/urls'
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions'
    import dates from '../../common/dates'
    import apis from '../../common/network'
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import store from '../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DatePickerPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(GridPlugin);

    let datePickerObj; 

    export default {
        components: {
        },
        data() {
            return {
                store: store,
                maxVal: new Date(),
                waterMark: 'Select a date',
                dateVal: dates.addDays(new Date(), -1),
                format: "dd/MM/yyyy",
                dateFormat: 'dd/MM/yyyy',
                periodSpans: SyncHelper.getDataManager('Utils/periodSpans'),
                periods: SyncHelper.getDataManager('Utils/marketPeriods'),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 4,
                        format: "n4"
                    }
                },
                yearParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 0,
                        format: "####"
                    }
                },
                dateParams: {
                    create: function () {
                        elem = document.createElement('input');
                        return elem;
                    },
                    read: () => {
                        return datePickerObj.value;
                    },
                    destroy: () => {
                        datePickerObj.destroy();
                    },
                    write: (args) => {
                        datePickerObj = new DatePicker({
                            value: new Date(args.rowData[args.column.field]),
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            //sets the max.
                            max: dates.addDays(new Date(), -1),
                            placeholder: 'Settlement Date',
                            firstDayOfWeek: 1
                        });
                        datePickerObj.appendTo(elem);
                    }
                },              
                extensions: ' .xls, .xlsx',
                multiple: false,
                derivedPricesData: this.$store.state.permissions["Permissions.LatestSettlement.View"]
                    ? SyncHelper.getDataManager("DerivedCurvePricingPerDay/ByDate") : [],
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 100, pageCount: 4 },
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: false,
                    allowAdding: false,
                    allowDeleting: false,
                    mode: 'Dialog'
                },
                toolbar: ['ExcelExport'],
                percentageRules: { required: true, number: true },
                requiredRules: { required: false },
                periodSpanRequiredRules: { required: false },
                nameRules: { required: true, maxLength: 50 },
                yearRules: { required: true, minLength: [(args) => { return args['value'].length == 4; }, 'Need 4 digits'] },
                filterOptions: gridOptions.filterSettings
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
            this.checkPermissionOnUser();
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Derived Curve Pricing.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            onUploadSuccess: function (args) {
                this.$refs.grid.refresh();
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {
                    this.toolbar = null;
                }

            },
        },
        computed: {
            gridQuery: function () {
                this.dateVal;
                let dateParam = this.dateVal?.toISOString().split('T')[0];
                var grid = document.getElementsByClassName("e-grid")[0]["ej2_instances"][0]; 
                //console.log("Grid instance:", grid);
                return new Query().addParams("date", dateParam);
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
        
</script>

<style scoped>
    .derived-price-padding {
        padding-top: 30px;
    }
</style>